import React from 'react';
import Geofence from '@uber/base-icons/geofence';
type propT = {
  strokeColor?: string;
  size?: number;
  title?: string;
};
const Icon = ({
  size = 16,
  strokeColor,
  title
}: propT) => {
  return <Geofence size={size} title={title ?? 'rectangle'} color={strokeColor} />;
};
export default Icon;